import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcChevronDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M3.36321 7.36321C3.71468 7.01174 4.28453 7.01174 4.636 7.36321L11.9996 14.7268L19.3632 7.36321C19.7147 7.01174 20.2845 7.01174 20.636 7.36321C20.9875 7.71469 20.9875 8.28453 20.636 8.63601L12.636 16.636C12.2845 16.9875 11.7147 16.9875 11.3632 16.636L3.36321 8.63601C3.01174 8.28453 3.01174 7.71469 3.36321 7.36321Z",
		fill: "currentColor"
	})
});
export default SvgIcChevronDown;
